export default __webpack_public_path__ + "locales/cs/PeopleTranslations.json?hash=26825aab044358aacd7453b272aa8e0d";